import { Construction } from "@mui/icons-material";

export const comparisonType = {
    EQUALS: true,
    NOT_EQUALS: false,
};

export const isJsonString = (str) => {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
}

export const isEmpty = (obj) => {
    for (const prop in obj) {
        if (Object.hasOwn(obj, prop)) {
            return false;
        }
    }

    return true;
}

export const toVariableNameFormat=(str) =>{
    if (str) {
      
      const cleanedStr = str.trim().replace(/[^a-zA-Z0-9 ]/g, "");
      const words = cleanedStr.split(" ");
      const formattedWords = words.map((word, index) => {
        if (index === 0) {
          return word.charAt(0).toLowerCase() + word.slice(1);;
        } else {
          return word.charAt(0).toUpperCase() + word.slice(1);
        }
      });
      return formattedWords.join("_");
    }
    return "component";
  }

export const countDecimals=(number) =>{
  try
  {
  if (Math.floor(number) !== number)
  return number.toString().split(".")[1].length || 0;
return 0;
  }
  catch(e)
  {
    return 0;
  }
}

export const getCommaSeparatedStrings = (object) => {
    let commaSeparatedValues = '';
    object.map((item) => {
        commaSeparatedValues += item + ',';
    });
    return commaSeparatedValues.substring(0, commaSeparatedValues.length - 1);
}

export const isStringEqualsOrNotEqualsNullOrEmpty = (string, isEquals) => {
    if (isEquals) {
        return (string === undefined || string === null || string === '');
    } else {
        return (string !== undefined && string !== null && string !== '')
    }
    
}

export const areEqualStrings = (string1, string2) => {
    if (isStringEqualsOrNotEqualsNullOrEmpty(string1, comparisonType.NOT_EQUALS)
        && isStringEqualsOrNotEqualsNullOrEmpty(string2, comparisonType.NOT_EQUALS)) {
        return string1.toUpperCase() === string2.toUpperCase();
    } else {
        return undefined;
    }
}

export const getArrayOfStringFromCommaSeparatedString = (string) => {
    if (string) {
        return string.split(',');
    } else return [];
}

export const removeElementFromArray = (obj, inputArray) => {
    if (!isEmpty(obj) && !isEmpty(inputArray)) {
        const array = [...inputArray];
        const index = array.indexOf(obj);

        if (index !== -1) {
            array.splice(index, 1);
        }
        
        return array;
    }
    return null;
}

export const filterNonMatchingElementsFromAnotherArray = (filterList, masterList) => {
    const result = masterList.filter(ml =>
        filterList.every(fl => fl !== ml));
    return result;
}